import React, { useState, useRef, useEffect } from 'react';
import ReactCrop, { Crop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import './ImageCrop.css';
interface ImageCropProps {
  imageUrl: string;
  onCropComplete: (croppedImageUrl: string) => void;
}

const ImageCrop: React.FC<ImageCropProps> = ({ imageUrl, onCropComplete }) => {
  const [crop, setCrop] = useState<Crop>({ unit: '%', width: 30, x: 0, y: 0, height: 30 });
  const [completedCrop, setCompletedCrop] = useState<Crop | null>(null);
  const imageRef = useRef<HTMLImageElement>(null);

  const handleCropComplete = (crop: Crop) => {
    setCompletedCrop(crop);
  };

  const handleSaveCrop = () => {
    if (!completedCrop || !imageRef.current) {
      return;
    }
    const croppedImageUrl = getCroppedImg(imageRef.current, completedCrop);
    onCropComplete(croppedImageUrl);
  };

  const getCroppedImg = (image: HTMLImageElement, crop: Crop): string => {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width!;
    canvas.height = crop.height!;
    const ctx = canvas.getContext('2d');

    ctx?.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width! * scaleX,
      crop.height! * scaleY,
      0,
      0,
      crop.width!,
      crop.height!
    );

    return canvas.toDataURL('image/jpeg');
  };

  return (
    <div>
      <ReactCrop
        crop={crop}
        onChange={newCrop => setCrop(newCrop)}
        onComplete={handleCropComplete}
        aspect={16 / 9}
      >
        <img ref={imageRef} src={imageUrl} alt="Crop" />
      </ReactCrop>
      <button className='Save-Crop' onClick={handleSaveCrop}>Save Crop</button>
    </div>
  );
};

export default ImageCrop;
